import { render, staticRenderFns } from "./StackedSingle.vue?vue&type=template&id=615a311a&scoped=true"
import script from "./StackedSingle.vue?vue&type=script&lang=js"
export * from "./StackedSingle.vue?vue&type=script&lang=js"
import style0 from "./StackedSingle.vue?vue&type=style&index=0&id=615a311a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a311a",
  null
  
)

export default component.exports